import ActionConstants, { Actions } from '../constants/actions';

const notificationsConstants = new Actions('Notifications')
  .add('add')
  .add('remove');

ActionConstants.add(notificationsConstants);

export default notificationsConstants.actionCreators();
